export enum ForgotStep {
  EMAIL = 'EMAIL',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}
